import React from 'react';
import MapPage from './MapPageLeaflet';
import {Paper} from 'material-ui';
import HomeMob from './HomeMob';
import {markers} from '../../libs/config';
import Notice from './Notice';
import NewsEvents from './NewsEvents';
import ImportantLinks from './ImportantLinks';
import CollapsiblePaper from '../common/CollapsiblePaper';
import TextTruncate from '../common/TextTruncate';
import MiniRainfallWatch from './MiniRainfallWatch';
import MiniRiverWatch from './MiniRiverWatch';

class Home extends React.Component {
  render() {
    const {mobView} = this.props;
    let style = {width: mobView ? '49%' : '100%'};
    return (
      <div className={mobView? '': 'inline-it'}>{
        mobView ?
          <HomeMob /> :
          <div className={'inline-it'} style={{maxWidth:'95%'}}>
            <div style={{width: mobView ? '100%' : '19%'}} className={mobView && 'inline-it'}>
              <CollapsiblePaper title="Notice" expand={true} containerHeight="406px" contentHeight="356px" style={style}>
                <Notice/>
              </CollapsiblePaper><br/>

              {/*<Paper zDepth={1} style={{...style, maxHeight: '406px'}}>*/}
              {/*/!*<h5 className="myTableHead">Notice Board</h5>*!/*/}
              {/*/!*<div style={{height: '358px', padding: '5px', overflowY: 'scroll', color: '#0f72a9'}}>*!/*/}
              {/*/!*<Notice/>*!/*/}
              {/*/!*</div>*!/*/}
              {/*</Paper>*/}


              <CollapsiblePaper title="News and Events" containerHeight="360px" contentHeight="320px" style={style}>
                <NewsEvents/>
              </CollapsiblePaper><br/>
              {/*<Paper zDepth={1} style={{...style, maxHeight: '360px'}}>*/}
              {/*<h5 className="myTableHead">News and Events</h5>*/}
              {/*<div style={{height: '315px', overflowY: 'scroll'}}>*/}
              {/*<NewsEvents/>*/}
              {/*</div>*/}
              {/*</Paper><br/>*/}

              <CollapsiblePaper title="Important Links" containerHeight="406px" contentHeight="356px" style={style}>
                <ImportantLinks/>
              </CollapsiblePaper><br/>
              {/*<Paper zDepth={1} style={{...style, maxHeight: '406px'}}>*/}
              {/*<h5 className="myTableHead">Important Links</h5>*/}
              {/*<div style={{height: '358px', padding: '5px', overflowY: 'scroll'}}>*/}
              {/*<ImportantLinks/>*/}
              {/*</div>*/}
              {/*</Paper>*/}


              <Paper zDepth={1} style={{...style, height: '240px'}}>
                <h5 className="myTableHead">NWP Products</h5>
                <a href='http://mfd.gov.np/nwp/' target="_blank" rel="noopener noreferrer" className="inline-it"
                   style={{marginTop: '5px', height:'74%', overflowY:'hidden'}}>
                  <img src={markers.nwp} alt="not found" className="img-responsive"
                       style={{...style, height: '137%', width: '190px'}}/>
                </a>
              </Paper>
            </div>
            <br/>

            <div style={{width: '60%'}} className="">
              <MapPage style={{width: '100%'}}/><br/>
              <Paper style={{width: '100%', textAlign: 'justify', padding: '5px', overflowY: 'scroll'}} zDepth={1}>
                <TextTruncate text={`Government of Nepal started hydrological and meteorological activities in an organized way in 1962. The activities were initiated as a section under the Department of Electricity. The section was subsequently transferred to the Department of Irrigation and Department Irrigation, Hydrology and Meteorology was formed. Later on in 1988, a separate department of Hydrology and Meteorology was established.

The Department of Hydrology and Meteorology (DHM) is an organization under the Ministry of Energy, Water Resources and Irrigation, Government of Nepal. The department with headquarter in Kathmandu has four regional  offices at Dharan, Pokhara, Bhairahawa and Kohalpur.

DHM has a mandate from Government of Nepal to monitor all the hydrological and meteorological activities in Nepal. No agency is entitled to carry out such activities without a proper liaison with DHM. The scope of work includes the monitoring of river hydrology, climate, agro-meteorology, sediment, air quality, water quality, limnology, snow hydrology, glaciology, wind and solar energy. DHM provides general and aviation weather forecasts, forecasting and early warning of hydro-meteorological hazards; and contributes to the global exchange of meteorological data on a regular basis as a member of the World Meteorological Organization (WMO).

DHM actively participates in the programs of relevant international organizations, such as, the UNESCO's International Hydrological Program (IHP) and WMO's Operational Hydrology Program (OHP). In the past, DHM has hosted several regional and international workshops, symposia, seminars and meetings on different aspects of meteorology, hydrology, sediment, and snow hydrology. The department is also a focal point for the Intergovernmental Panel on Climate Change (IPCC) and for the meteorological activities of the South Asian Association for Regional Co-operation (SAARC). The International Civil Aviation Organization (ICAO) has recognized DHM as an authority to provide meteorological services for international flights.`}/>
              </Paper>
            </div>

            <br/>

            <div style={{width: '19%'}}>
              <MiniRiverWatch/><br/>
              <MiniRainfallWatch/><br/>
              <Paper zDepth={1} style={{height: 'inherit'}}>
                <h5 className="myTableHead">Weather Forecast</h5>
                <a href="http://mfd.gov.np" target="_blank" rel="noopener noreferrer"
                   style={{...style, height: '120px'}} className="inline-it">
                  <img className="img-responsive" src={markers.mfd} alt="not found" style={{maxHeight: '120px'}}/>
                </a>
              </Paper>
            </div>
          </div>
      }</div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home/Home.js